import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/c2622c69-be67-4ead-9fd4-1579e645a9a6";
export const REGISTER_URL = "https://a.ntrk2.com/44074156-6dd4-4eac-ba7e-1c484d100688";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://fun678.load2app.com/download?id=kd3u5htq3npvdrf";

export * from "./codes";
export * from "./context";
